export default (Alpine) => {
    Alpine.data("parallax", () => ({
       visibleSection: null,

        init() {
            this.fixedImages = document.querySelectorAll('[data-fixed-image]');
        },

        sectionEnter(value) {
            console.log('sectionEnter');
        },

        sectionLeave(value) {
            console.log('sectionLeave');
        }
    }));
};